import { Provider } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../../core/use-case";
import { CreateFakeResourcePayload } from "../../models/contract-resource.model";
import { Resource } from "../../models/personnel.model";
import { HrRepository } from "../../repositories/hr.repository";

export class CreateFakeResourceUseCase
  implements UseCase<CreateFakeResourcePayload, Resource>
{
  constructor(private repo: HrRepository) {}

  execute(param: CreateFakeResourcePayload): Observable<Resource> {
    return this.repo.createFakeResource(param);
  }
}

const createFakeResourceUseCaseFactory = (repo: HrRepository) =>
  new CreateFakeResourceUseCase(repo);

export const createFakeResourceUseCaseProvider: Provider = {
  provide: CreateFakeResourceUseCase,
  useFactory: createFakeResourceUseCaseFactory,
  deps: [HrRepository],
};
